export default __webpack_public_path__ + "static/media/card-w-review@2x.ced61bdf.png";